import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const Loading = ({ className }) => <div className={classnames(styles.loading, className)} />;

export default Loading;
